import React, {Fragment, useState} from "react";
import {EyeFill, EyeSlashFill} from "react-bootstrap-icons";

import './FormInputFileUpload.scss' ;
import TooltipIcon from "@ui/Tooltip/TooltipIcon";

const FormInputFileUpload = ({
                                 register,
                                 watch,
                                 document,
                                 readOnly,
                                 sectionName,
                                 name,
                                 maxFileSizeMb,
                                 className,
                                 validMimeTypes = ["image/jpeg", "image/png", "image/gif"],
                                 formErrors,
                                 maxLength,
                                 required,
                                 placeHolder,
                                 autocomplete
                             }) =>
{
    const classText = className === undefined ? "form-control" : '';

    const curVal = watch(sectionName + '.' + name);

    if (curVal === null || curVal === undefined || curVal instanceof FileList || curVal.length === 0)
    {
        return (

            <Fragment>
                <input
                    readOnly={readOnly}
                    className={classText}
                    type="file"
                    {...register(sectionName + '.' + name, {
                        required: "Please select a file",
                        validate: {
                            fileSize: (value) => {
                                if (!value[0])
                                {
                                    return true;
                                }
                                return value[0].size <= maxFileSizeMb * 1024 * 1024 || "File size must be less than " + maxFileSizeMb + "MB";
                            },
                            fileType: (value) => {
                                if (!value[0])
                                {
                                    return true;
                                }
                                return (
                                    validMimeTypes.includes(value[0].type) ||
                                    "Invalid document format. Please upload Word or PDF documents only."
                                );
                            },
                        },
                    })}
                />
            </Fragment>
        )
    }
    else
    {
        const doc_id = document.enc_doc_id;

        return (
            <div className='file-container'>
                <div>
                    <input readOnly={true}
                           placeholder={placeHolder}
                           className={classText} {...register(sectionName + '.' + name, {
                        required: required,
                    })} />
                </div>
                <div className='view-icon'>
                    <TooltipIcon text='View Document' component={EyeFill} link={'/api/v1.0/documents/' + doc_id + '/image'} target="_blank" color="var(--s360-icon-blue)"/>
                </div>
            </div>
        )
    }
}

export {
    FormInputFileUpload
} ;
